<template>
    <div id="app">
        <a-config-provider :locale="locale">
            <home-page/>
        </a-config-provider>
    </div>
</template>

<script>
// import HomePage from '@/components/HomePage/HomePage'
import HomePage from '@/layout/HomePage'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { mapMutations } from 'vuex'
export default {
    name: 'App',
    components: {
        HomePage
    },
    data() {
        return {
            locale: zhCN,
        };
    },
    mounted() {
        window.onresize = () => {
            this.changePhoneView(this.$windowUtil.getViewportOffset().x < 560)
        },
        window.onscroll = () => {
            this.changeBodyScroll(document.body.scrollTop || document.documentElement.scrollTop)
        }
        // 随机生成favicon
        const favicons = ['x', 'u', 'c', 'h', 'e', 'n', 'o', 'a', 'k'];
        const randomIndex = Math.floor(Math.random() * favicons.length);
        const favicon = document.querySelector('link[rel="icon"]');
        favicon.href = `/favicon/${favicons[randomIndex]}.png`;
    },
    methods: {
        ...mapMutations(['changePhoneView', 'changeBodyScroll'])
    },
}
</script>

<style>
body::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #eee;
}
body::-webkit-scrollbar-thumb {
    background-color: #bbb;
    border-radius: 20px;
}
</style>
